import {
  SKIP,
  custom,
  deserialize,
  list,
  object,
  optional,
  serializable,
} from 'serializr';
import { User } from '@models/user.model';
import { TestDevice } from './test-device.model';
import { MobileInspection } from '../pages/mobile-inspector/models/mobile-inspection.model';
import { Subscription } from '@models/subscription.model';

export enum TestPlanRunType {
  ADHOC = 'ADHOC',
  }

export class TestPlanLicenseUsage {
  @serializable
  testPlanName: string;

  @serializable
  buildNumber: string;

  @serializable
  testPlanResultId: number;

  @serializable
  testPlanId: number;

  @serializable
  adhocTestCaseResultId: number;

  @serializable
  parallelCount: number;

  @serializable
  testPlanRunType: TestPlanRunType;

  @serializable(optional(object(User)))
  executedBy: User;

  @serializable
  dryRunTestCaseName: string;

  @serializable
  startTime: Date;

  @serializable
  projectName: string;

  @serializable
  applicationName: string;

  @serializable
  versionName: string;

  @serializable(optional(list(object(TestDevice))))
  public testDevices: TestDevice[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestPlanLicenseUsage, input));
  }

  isDry() {
    return this.testPlanRunType == TestPlanRunType.ADHOC;
  }
}

export class DebuggerUsageDetails {
  @serializable
  testPlanName: string;

  @serializable
  buildNumber: number;

  @serializable
  testPlanId: number;

  @serializable
  testPlanResultId: number;

  @serializable
  adhocTestCaseResultId: number;

  @serializable
  dryRunTestCaseName: string;

  @serializable
  parallelCount: number;

  @serializable
  testPlanRunType: string;

  @serializable(optional(object(User)))
  executedBy: User;

  @serializable
  startTime: Date;

  @serializable
  projectName: string;

  @serializable
  applicationName: string;

  @serializable
  versionName: string;

  @serializable(optional(list(object(TestDevice))))
  public testDevices: TestDevice[];
}

export class LicenseUsageDetails {
  @serializable
  usedParallelRuns: number;

  @serializable
  usedQueueSize: number;

  @serializable
  usedAdditionalParallelRunsOnLocal: number;

  @serializable
  usedAdditionalParallelRunsOnCloud: number;

  @serializable
  usedFreeLocalOnlyMobileSessions: number;

  @serializable(list(object(TestPlanLicenseUsage)))
  testPlanLicenseUsageDetails: TestPlanLicenseUsage[];

  @serializable(list(object(DebuggerUsageDetails)))
  debuggerUsageDetails: DebuggerUsageDetails[];

  @serializable(list(object(MobileInspection)))
  mobileInspectionLicenseUsageDetails: MobileInspection[];

  @serializable(object(Subscription))
  subscription: Subscription;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(LicenseUsageDetails, input));
  }
}
